import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import { ETaxType } from 'src/models/enum';
import { SPV } from 'src/models/index';

countries.registerLocale(en);

/**
 * Determines which tax type to use for a given SPV. For example KESt for Austria and KapESt for Germany.
 * @param spv The SPV to determine the tax type for.
 * @returns The tax type to use for the given SPV (ETaxType).
 */
export const determineWhatTaxType = (spv: SPV) => {
  const country = spv?.address?.countryCode;
  switch (country) {
    case countries.getAlpha3Code('Austria', 'en'):
    case 'Österreich' as countries.Alpha3Code: // legacy support
    case 'Austria' as countries.Alpha3Code: // legacy support
      return ETaxType.KESt;
    case countries.getAlpha3Code('Germany', 'en'):
    case 'Deutschland' as countries.Alpha3Code: // legacy support
    case 'Germany' as countries.Alpha3Code: // legacy support
      return ETaxType.KapESt;
    default:
      return ETaxType.none;
  }
};
